var _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarChart2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 23 23",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-bar-chart-2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 20,
    x2: 18,
    y2: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12,
    y2: 4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 20,
    x2: 6,
    y2: 14
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart2);
export default __webpack_public_path__ + "static/media/bar-chart-2.92ce2099ab659e329a2673ecda02e808.svg";
export { ForwardRef as ReactComponent };